import styled from 'styled-components';
import {
  Input as AntInput,
  Select as AntSelect,
  DatePicker as AntDatePicker,
  Button as AntButton,
} from 'antd';

export const Title = styled.h3`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* 1 */

  color: #1c1c1c;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const InputStyled = styled(AntInput)`
  height: 48px;
  background: #ffffff;
  /* neutral 20 */

  border: 1px solid #ececec !important;
  box-sizing: border-box;
  border-radius: 4px;
`;

export const StyledDatePicker = styled(AntDatePicker)`
  height: 48px;
  border: 1px solid #ececec !important;
  border-radius: 4px;
  width: 100%;
`;

export const SelectStyled = styled(AntSelect)`
  height: 48px;
  background: #ffffff;
  width: 100%;
  display: block;
  /* neutral 20 */

  //border: 1px solid #ECECEC !important;
  box-sizing: border-box;
  border-radius: 4px;
  & > .ant-select-selector {
    border-radius: 4px !important;
    height: 100% !important;
    border: 1px solid #ececec !important;
  }
  & input {
    height: 48px !important;
    line-height: 48px !important;
    ::placeholder {
    }
  }
  & .ant-select-selection-placeholder {
    line-height: 48px !important;
  }
  & > .ant-select-arrow {
    color: #1c1c1c;
  }
`;

export const StyledButton = styled(AntButton)`
  height: 48px;
  border: 1px solid #ececec !important;
  border-radius: 4px;
  width: 100%;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  /* identical to box height */

  //display: flex;
  //align-items: center;

  /* 1 */

  color: #1c1c1c;
  background: #f6f6f6;
`;

export const StylesTextArea = styled(AntInput.TextArea)`
  border: 1px solid #ececec !important;
  resize: none;
`;

export const InputLabel = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 8px;
  /* identical to box height */

  display: flex;
  align-items: center;

  /* 1 */

  color: #1c1c1c;
`;

export const RadioWrapper = styled.div`
  display: grid;
  gap: 24px 20px;
  grid-template-columns: repeat(3, minmax(auto, auto));
`;

export const RadioItemInfo = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > span {
    margin-left: 14px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height */

    display: flex;
    align-items: center;

    /* 1 */

    color: #1c1c1c;
  }
  
  & > svg {
    max-height: 24px;
    max-width: 34px;
  }
  & > img {
    max-height: 24px;
    max-width: 34px;
  }
`;

export const RadioItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 12px;
  transition: 0.3s ease all;
  cursor: pointer;
  /* neutral 20 */

  border: 1px solid ${({ checked }) => (checked ? '#002637' : '#ECECEC')};
  box-sizing: border-box;
  border-radius: 4px;

  :hover {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #002637;
    border-color: #002637;
  }
`;

export const FlexBox = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const DraggerWrapper = styled.div`
  height: 200px;
`;
